import React, { Component, PropTypes } from 'react'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'
import CircularProgress from 'material-ui/CircularProgress'
import { CardTitle, CardActions } from 'material-ui/Card'
import ContentFilter from 'material-ui/svg-icons/action/list'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import typography from 'material-ui/styles/typography'
import api from '../../api'
import config from '../../config'
import { setSnackbarMessage } from '../../actions/snackbar'

const styles = {
  h3: {
    marginBottom: '1em',
    fontWeight: typography.fontWeightLight,
    fontSize: 22
  },
  cardActions: {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
    padding: '14px 0',
    marginRight: -8
  }
}

class ImpersonateUser extends Component<any, any> {
  constructor () {
    super()
    this.state = {
      user: null
    }
  }

  componentWillMount () {
    api.get(`admin/users/${this.props.params.userId}`)
      .then(res => res.json())
      .then(user => {
        this.setState({ user })
      })
  }

  handleImpersonate (e) {
    e.preventDefault()

    api.post('auth/impersonate', { body: { user_id: this.props.params.userId } })
      .then(res => {
        if (res.ok) {
          window.location.href = config.webUrl
        } else {
          this.props.setSnackbarMessage('An error occurred while attempting to impersonate the user.')
        }
      })
  }

  render () {
    const { user } = this.state

    if (!user) {
      return <div><CircularProgress /></div>
    }

    return (
      <div>
        <CardActions style={styles.cardActions}>
          <FlatButton onClick={() => browserHistory.push('/security/users')} icon={<ContentFilter />} title='Return to list' />
        </CardActions>

        <CardTitle title='Impersonate User' style={{ paddingLeft: 0 }} />

        <div>
          <h3 style={styles.h3}>You are about to impersonate {user.name} ({user.email}).</h3>
          <h3 style={styles.h3}>Click the button below to continue.</h3>
          <RaisedButton label='Impersonate' primary onClick={e => this.handleImpersonate(e)} />
        </div>
      </div>
    )
  }
}

// @ts-ignore
ImpersonateUser.propTypes = {
  setSnackbarMessage: PropTypes.func.isRequired
}

export default connect(null, { setSnackbarMessage })(ImpersonateUser)
